module.exports = __webpack_public_path__ + "static/img/vip-header-3-zh.8568626.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/priceCard/vip-header-3-zh.png
// module id = t38P
// module chunks = 1